<div class="db-main">
  <div class="db-main__content"
       [class.with-notif]="(userSubscription?.trialClient || userSubscription?.trialBoosterClient) && !user?.emailVerified">
    <div class="db-overview" id="db-overview">
      <db-overview-page-header
        [user]="user" [userSubscription]="userSubscription"
        [website]="website" [demoUser]="demoUser"
        [hostingInfoData]="hostingInfoData"
        [primaryChanged]="primaryChanged"
      ></db-overview-page-header>
<!--
      <db-cdn-notice [websiteId]="website?.id"></db-cdn-notice>
-->
      <div class="containers-wrap" [ngClass]="{'db-page-with-banner': hasHostingBanner}">
        <div class="container">
          <div class="row">
            @if (hosting_services && website.domain_hash) {
              <div>
                  <div class="db-wordpress-resource_storage-widget inner-container">
                      <db-visits-widget [demoUser]="demoUser" [website]="website"></db-visits-widget>
                  </div>
              </div>
            }
          </div>
          <div class="row">
            @if ((website?.type !== 'staging' && desktopScore && !website.parentId && !website.isNetwork)) {
              <div class="long">
                <div class="db-plugins-widget inner-container long">
                  <db-overview-plugins-widget [website]="website" [demoUser]="demoUser"></db-overview-plugins-widget>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
